import React, { ReactElement, useState } from 'react'
import { ClusterOutlined } from '@ant-design/icons'
import { Menu } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import Sider from 'antd/lib/layout/Sider'
import { Container } from '@components/style'
import { useNavigate } from 'react-router-dom'

export default function TransportadoraSider(): ReactElement {
  const navigate = useNavigate()
  const [isCollapsed, setIsCollapsed] = useState(false)
  const breakpoint = useBreakpoint()

  return (
    <Container>
      <Sider
        breakpoint='xl'
        collapsed={isCollapsed}
        onBreakpoint={(broken) => setIsCollapsed(broken)}
        onCollapse={(broken) => setIsCollapsed(broken)}
        width={230}
        className='sidebar'
        collapsedWidth={breakpoint.sm ? 40 : 0}
        theme='light'
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
        }}
      >
        <Menu mode='inline' style={{ height: '100%' }}>
          <Menu.Item
            key='cargas'
            onClick={() => navigate('cargas')}
            icon={<ClusterOutlined />}
          >
            Cargas
          </Menu.Item>
        </Menu>
      </Sider>
    </Container>
  )
}
